module.exports = {
  GIVE: 1,
  RECEIVE: 2,
  LEND: 3,
  BORROW: 4
}
